import { withSchema } from '@websolutespa/bom-core';
import { Drawer as DrawerBase } from './drawer';
import { DrawerContent } from './drawer-content';
import { DrawerDialog } from './drawer-dialog';
import { DrawerHeader } from './drawer-header';
import { DrawerSubtitle } from './drawer-subtitle';
import { DrawerTitle } from './drawer-title';

export const Drawer = withSchema(
  DrawerBase,
  {
    Dialog: DrawerDialog,
    Header: DrawerHeader,
    Title: DrawerTitle,
    Subtitle: DrawerSubtitle,
    Content: DrawerContent,
  }
);

export type { DrawerProps } from './drawer';
export type { DrawerContentProps } from './drawer-content';
export type { DrawerDismissProps } from './drawer-dismiss';
export type { DrawerHeaderProps } from './drawer-header';
export type { DrawerSubtitleProps } from './drawer-subtitle';
export type { DrawerTitleProps } from './drawer-title';

export * from './drawer.variants';

